import React from 'react';

import Alert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import { connect } from 'react-redux';

import Icons from 'consts/icons';
import { addAlert } from 'store/actions/alert/alerts';
import { postRequest } from 'helpers/apiRequests';
import { useLoginStyles } from 'consts/styles/Login';

const PasswordReset = props => {
  const { dispatch, language, setType } = props;
  const [showSuccessMessage, setShowSuccessMessage] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [values, setValues] = React.useState({
    email: '',
  });
  const [error, setError] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState(false);

  const classes = useLoginStyles();

  const handleChange = event => {
    const { target } = event;
    const { name, value } = target;

    setValues({
      ...values,
      [name]: value,
    });
    setError(!testEmail(value));
  };

  const sendEmail = () => {
    setLoading(true);
    postRequest('resetPassword', {
      email: values.email,
    }).then(result => {
      setLoading(false);
      if (result?.status === 200) setShowSuccessMessage(true);
      else {
        setErrorMsg(true);
        dispatch(
          addAlert({
            title: language.alerts[result.data.code].title_,
            desc: language.alerts[result.data.code].desc_,
            type: 'error',
          })
        );
      }
    });
  };

  const handleLoading = !loading ? (
    language.resetPassword.emailPage.button_
  ) : (
    <div className={`${classes.Login}__loader`}>
      <div className={`${classes.Login}__loader__text`}>
        {language.resetPassword.emailPage.sending_}
      </div>
      <div className={`${classes.Login}__loader__dot-flashing`}></div>
    </div>
  );

  const testEmail = field => {
    // eslint-disable-next-line no-control-regex
    const reg = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
    return reg.test(field);
  };

  const handleLogin = () => {
    setType('login');
  };

  const handleEnterClick = event => {
    if (event.key === 'Enter') {
      sendEmail();
    }
  };

  const handleErrors = () => {
    if (showSuccessMessage) {
      return (
        <Alert
          severity="success"
          className={`${classes.Login}__message ${classes.Login}__message--border--success`}
        >
          {language.resetPassword.emailPage.successMsg_}
        </Alert>
      );
    }
    if (errorMsg) {
      return (
        <Alert
          severity="error"
          className={`${classes.Login}__message ${classes.Login}__message--border--error`}
        >
          {language.alerts.loginError.desc_}
        </Alert>
      );
    }
    return (
      <div
        className={`${classes.Login}__message ${classes.Login}__message--hidden`}
      >
        &nbsp;
      </div>
    );
  };

  return (
    <>
      <div className={`${classes.Login}__card__header`}>
        {language.resetPassword.emailPage.header_}
      </div>
      <form className={`${classes.Login}__card__form`} noValidate>
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="username"
          label={language.resetPassword.emailPage.email_}
          name="email"
          autoComplete="email"
          autoFocus
          onChange={handleChange}
          onKeyPress={handleEnterClick}
          defaultValue={values.email}
          type="email"
          error={error}
          helperText={error && language.requiredField}
        />
        <Button
          type="button"
          fullWidth
          className={`${classes.Login}__card__submit`}
          onClick={sendEmail}
          style={{ marginTop: 16 }}
        >
          {handleLoading}
        </Button>
        <Grid container className={`${classes.Login}__card__links`}>
          <Grid item xs>
            <Link variant="body2" onClick={handleLogin}>
              <Icons.Navigation.BackToLogIn />
              &nbsp;&nbsp;{language.resetPassword.emailPage.backMsg_}
            </Link>
          </Grid>
        </Grid>
        {handleErrors()}
      </form>
    </>
  );
};

PasswordReset.propTypes = {
  dispatch: PropTypes.func,
  language: PropTypes.object.isRequired,
  setType: PropTypes.func,
};

const mapStateToProps = state => ({
  language: state.language,
});

export default connect(mapStateToProps)(PasswordReset);
